<template>
    <v-form
        @submit.prevent="submitForm"
        ref="form"
        class="action-form mx-auto"
        style="max-width: 400px"
        v-model="isFormValid"
    >
        <v-card class="mx-auto EK-card IMThemeGray rounded-xl rounded-tl-0">
            <v-card-title class="p-2"></v-card-title>
            <v-card-text class="pt-3 text-right mainLabelsColor">
                <div>
                    <div v-show="adIndex == -1">
                        <label>نوع الإدخال</label>
                        <v-row>
                            <v-col cols="9">
                                <v-text-field id="type"
                                              v-model="typeName"
                                              class="rounded-tl-0 ma-0 pa-0"
                                              rounded
                                              dense
                                              solo
                                              readonly></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-switch class="switch ma-0 pa-0 pt-2"
                                          v-model="switchType"
                                          color="IMThemeOrange"
                                          dark></v-switch>
                            </v-col>
                        </v-row>
                    </div>

                    <label for="cat-image">صورة {{ switchType ? " العرض" : "الإعلان" }}</label>
                    <div class="image-container text-center">
                        <img :src="
                                !this.currentAd.image[0]
                                    ? placeholder
                                    : !!this.currentAd.image[0].path
                                    ? domainHost +
                                      this.currentAd.image[0].path.replace(
                                          '~',
                                          ''
                                      )
                                    : this.currentAd.image[0].base64
                            "
                             alt="ads image"
                             class="w-100 rounded-xl"
                             style="max-height: 170px" />
                    </div>
                    <span class="text-danger" v-if="!this.currentAd.image[0]">يجب تحديد صورة</span>
                    <div v-if="typeName == 'عرض'">
                        <dragDropImage @uploaded="dragDropImage"
                                       id="image"
                                       title="أضف صورة"
                                       class="overflow-hidden"
                                       style="height: 38px; justify-content: flex-end; padding: 7px" />
                    </div>

                    <v-row class="my-2" v-else>
                        <v-col>
                            <v-btn color="light"
                                   block
                                   elevation="13"
                                   rounded
                                   @click="uploadImageAd">
                                اضافة صورة
                            </v-btn>
                            <small class="text-warning">مواصفات الصورة المستحسنة : ابعاد 3:2</small>

                        </v-col>

                    </v-row>
                </div>
                <div v-if="type == 2">
                    <label for="storeName">اسم المشترك</label>
                    <v-autocomplete
                        class="rounded-tl-0 ma-0 pa-0"
                        id="store"
                        auto-select-first
                        dense
                        rounded
                        solo
                        color="IMThemeGray"
                        item-color="IMThemeGray"
                        :items="shopsList"
                        v-model="currentAd.shopId"
                        :rules="selectShopFor"
                        item-text="name"
                        item-value="id"
                    ></v-autocomplete>
                </div>
                <div v-else>
                    <label for="cityName">اسم المدينة</label>
                    <v-autocomplete
                        class="rounded-tl-0"
                        id="store"
                        auto-select-first
                        dense
                        rounded
                        solo
                        color="IMThemeGray"
                        item-color="IMThemeGray"
                        :items="citiesList"
                        :rules="selectCityFor"
                        v-model="currentAd.cityId"
                        item-text="name"
                        item-value="id"
                    ></v-autocomplete>
                </div>
                <label for="adDates"
                    >تاريخ {{ switchType ? "العرض" : "الإعلان" }}</label
                >
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="currentAd.adDates"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item
                            class="white rounded-tl-0 rounded-xl"
                            v-bind="attrs"
                            v-on="on"
                            dense
                        >
                            <v-chip
                                small
                                v-for="(date, i) in currentAd.adDates"
                                class="ml-1"
                                :key="i"
                            >
                                {{ date }}
                            </v-chip>
                            <v-icon class="mr-auto">mdi-calendar</v-icon>
                        </v-list-item>
                    </template>
                    <v-date-picker
                        v-model="currentAd.adDates"
                        color="IMThemeGray"
                        locale="ar-sy"
                        range
                    >
                        <v-spacer></v-spacer>
                        <v-btn text color="IMThemeGray" @click="menu = false">
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="IMThemeGray"
                            @click="$refs.menu.save(currentAd.adDates)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
                <small class="text-danger" v-if="isValidDateRange"
                    >الحقل يجب أن يحتوي على تاريخين - تاريخ البداية فيه أصغر من
                    تاريخ النهاية</small
                >
                <div v-if="type == 2">
                    <label for="description">التفاصيل</label>
                    <v-textarea
                        :rules="descriptionRules"
                        v-model="currentAd.description"
                        class="rounded-tl-0"
                        color="secondary"
                        id="description"
                        rounded
                        solo
                    ></v-textarea>
                </div>
            </v-card-text>
            <v-card-text class="p-0 text-center">
                <v-btn
                    block
                    class="IMThemeOrange text-white rounded-0 flex-grow-1"
                    type="submit"
                    :disabled="
                        !isFormValid ||
                            !this.currentAd.image[0] ||
                            isValidDateRange
                    "
                >
                    {{
                        adIndex == -1
                            ? switchType
                                ? "إضافة عرض"
                                : "إضافة إعلان"
                            : "تعديل"
                    }}
                </v-btn>
                <v-btn
                    v-if="adIndex != -1"
                    outlined
                    rounded
                    color="white"
                    @click="goToAdd"
                    class="rounded-tl-0 mt-3"
                >
                    إلغاء التحديد
                </v-btn>
            </v-card-text>
            <v-card-actions class="p-3"></v-card-actions>

            <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="700">
                    <v-card>
                        <vue-anka-cropper
                            @cropper-saved="handleImageSave"
                            ref="croper"
                            :options="{
                                dropareaMessage:
                                    'اسحب الصورة الى هنا او اضغط الزر ادناه',
                                            previewQuality: 1,
                                           maxFileSize: false,
                                          resultQuality: 1,
                                aspectRatio: 1.5,
                                          croppedHeight:false,
                                          croppedWidth:false,
                                showPreview: false,
                                selectButtonLabel: 'اختر صورة',
                                frameStrokeColor: '#ff5f01',
                                handleFillColor: '#ff5f01',
                                handleHoverFillColor: '#ff5f01',
                                handleHoverStrokeColor: '#ff5f01'
                            }"
                        ></vue-anka-cropper>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="#2b2b2b" text @click="dialog = false">
                                إلغاء
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-card>
    </v-form>
</template>

<script>
import vueAnkaCropper from "vue-anka-cropper";
import { mapActions, mapGetters } from "vuex";
import dragDropImage from "@/components/drag-drop-images.vue";
import { singleImageCompressor } from "@/plugins/fileCompresser.service.js";
import "vue-anka-cropper/dist/VueAnkaCropper.css";
export default {
    props: {
        adIndex: String,
        type: String
    },
    components: {
        dragDropImage,
        vueAnkaCropper
    },
    computed: {
        ...mapGetters([
            "currentAd",
            "placeholder",
            "domainHost",
            "citiesList",
            "shopsList"
        ])
    },
    data: () => ({
        dialog: false,
        menu: false,
        isFormValid: false,
        switchType: false,
        isValidDateRange: false,
        typeName: "إعلان",
        selectShopFor: [v => !!v || "يرجى اختيار مشترك"],
        selectCityFor: [v => !!v || "يرجى اختيار مدينة"],

        descriptionRules: [
            v => !!v || "يرجى كتابة وصف",
            v => (v && v.length >= 3) || "التفاصيل يجب أن تكون أطول من 3 محارف"
        ]
    }),
    created() {
        if (this.adIndex >= 0) {
            this.fetchCurrentAd(this.adIndex);
        } else {
            this.resetAdDto();
        }

        this.switchType = this.type == 2;
        this.setAdType(this.type);

        this.offset = this.getOffset(
            document.querySelector(".action-form")
        ).top;
        setTimeout(() => {
            window.scrollTo(this.offset, this.offset);
        }, 100);
    },
    methods: {
        getOffset(el) {
            var _x = 0;
            var _y = 0;
            while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
                _x += el.offsetLeft - el.scrollLeft;
                _y += el.offsetTop - el.scrollTop;
                el = el.offsetParent;
            }
            return { top: _y, left: _x };
        },
        ...mapActions(["fetchCurrentAd", "resetAdDto", "setAdType"]),
        submitForm() {
            this.$store.dispatch("setAd", this.currentAd);
        },
        goToAdd() {
            this.$router.push("./../1/-1");
            this.resetAdDto();
        },
        uploadImageAd() {

            this.dialog = true;
        },

        handleImageSave(e) {
            singleImageCompressor(e.croppedFile, this.currentAd.image);
            this.dialog = false;
        },

        dragDropImage(e) {
            singleImageCompressor(e, this.currentAd.image);

         }

    },
    watch: {
        "currentAd.adDates"(v) {
            this.isValidDateRange = !(
                !!v &&
                v.length == 2 &&
                new Date(v[1]) > new Date(v[0])
            );
        },
        adIndex(index) {
            if (index >= 0) {
                this.fetchCurrentAd(index);
            } else {
                this.resetAdDto();
            }

            this.offset = this.getOffset(
                document.querySelector(".action-form")
            ).top;
            setTimeout(() => {
                window.scrollTo(this.offset, this.offset);
            }, 100);
        },
        type(data) {
          
            this.currentAd.type = data;
            this.switchType = data == 2;
            // are you modify change type and update
        },
        switchType(data) {
            if (data) {
                this.$router.push(`/ad/2/${this.adIndex}`);
                this.typeName = "عرض";
            } else {
                this.$router.push(`/ad/1/${this.adIndex}`);
                this.typeName = "إعلان";
            }
        }
    }
};
</script>
<style lang="scss">
.v-input__slot {
    justify-content: center;
}
.ankaCropper__navigation a:not(:last-child) {
    display: none;
}
.ankaCropper__navigation {
    min-height: 60px;
    background: #fff !important;
}
.ankaCropper__navigation a {
    height: 100% !important;
    display: flex;
    background: #313131 !important;
    color: #fff !important;

    svg {
        display: none;
    }
}
.ankaCropper {
    box-shadow: none !important;
}
.ankaCropper.light .ankaCropper__droparea {
    border: 2px dashed var(--v-IMThemeOrange-base);
}
.ankaCropper__selectButton {
    background-color: #313131 !important;
}
</style>
